import { defineNuxtRouteMiddleware, useCookie, useNuxtApp, useRuntimeConfig } from "#imports";
import { useAuth } from "../store/auth.store.js";
import { safelyNavigateTo } from "@malt/utils";
export default defineNuxtRouteMiddleware(async (to) => {
  const nuxtApp = useNuxtApp();
  const { $pinia } = nuxtApp;
  const store = useAuth($pinia);
  const pathOfWorkflowInProgressCookie = useCookie("path-of-mandatory-workflow-likely-in-progress");
  const pathOfWorkflowLikelyInProgress = pathOfWorkflowInProgressCookie.value?.split("?")[0];
  if (!pathOfWorkflowLikelyInProgress) {
    return;
  }
  const baseURL = useRuntimeConfig().app.baseURL;
  const currentPath = baseURL === "/" ? to.path : baseURL + to.path;
  if (
    // we must let the user consult these pages at all times
    currentPath === "/legal" || currentPath.startsWith("/about/privacy")
  ) {
    return;
  }
  if (!shouldRedirectUserTo(pathOfWorkflowLikelyInProgress)) {
    return;
  }
  function shouldRedirectUserTo(pathWhereToRedirectUser2) {
    if (currentPath.startsWith("/account/email") && pathWhereToRedirectUser2.startsWith("/signup-client/email-verification")) {
      return false;
    }
    return currentPath !== pathWhereToRedirectUser2 && (pathWhereToRedirectUser2 === "/" || !currentPath.startsWith(pathWhereToRedirectUser2));
  }
  const { pathWhereToRedirectUser } = await store.checkIfLoggedOrIfNeedingRedirect();
  if (pathWhereToRedirectUser && shouldRedirectUserTo(pathWhereToRedirectUser)) {
    return safelyNavigateTo({ path: pathWhereToRedirectUser }, { externalToThisApp: true });
  }
});
